import { Component } from '@angular/core';

@Component({
  selector: 'app-data-import-configuration',
  templateUrl: './data-import-configuration.component.html',
  styleUrls: ['./data-import-configuration.component.scss']
})
export class DataImportConfigurationComponent { }
